import { render, staticRenderFns } from "./infoCliente.vue?vue&type=template&id=07673616&scoped=true&"
import script from "./infoCliente.vue?vue&type=script&lang=js&"
export * from "./infoCliente.vue?vue&type=script&lang=js&"
import style0 from "./infoCliente.vue?vue&type=style&index=0&id=07673616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07673616",
  null
  
)

export default component.exports